import LoaderDualRings from '~/components/loaders/DualRings'

export default {
  components: { LoaderDualRings },

  props: {
    // text
    text: {
      type: String,
      required: true,
    },
    textSize: {
      type: String,
      default: '14px',
    },
    textBold: {
      type: Boolean,
      default: false,
    },
    textUppercase: {
      type: Boolean,
      default: false,
    },

    // colors
    color: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      required: true,
    },
    borderColor: {
      type: String,
      required: true,
    },

    // lifecycle
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    // internal path for nuxt-link element
    to: {
      type: String,
      default: undefined,
    },
    // url for native href
    href: {
      type: String,
      default: undefined,
    },
    target: {
      type: String,
      default: '_blank',
    },

    fullWidth: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    noFocus: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    componentIs () {
      if (this.disabled || this.loading) { return 'button' }
      if (this.href) { return 'a' }
      if (this.to)   { return 'nuxt-link' }
      return 'button'
    },
    computedTarget () {
      return this.href ? this.target : undefined
    },

    classes () {
      return {
        [`${this.CLASS_BASE}--loading`]: this.loading,
        [`${this.CLASS_BASE}--disabled`]: this.loading || this.disabled,
        [`${this.CLASS_BASE}--full-width`]: this.fullWidth,
        [`${this.CLASS_BASE}--no-padding`]: this.noPadding,
        [`${this.CLASS_BASE}--no-focus`]: this.noFocus,
      }
    },
    style () {
      return {
        color: this.color,
        borderColor: this.borderColor,
        backgroundColor: this.bgColor,
        fontSize: this.textSize,
      }
    },
  },

  methods: {
    click (e) {
      if (this.loading || this.disabled) { return e.preventDefault() }
      if (this.href || this.to) { return }

      e.preventDefault()
      this.$emit('click', e)
    },
  },
}
